<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pt-3 tw-pb-3.5">
        <base-breadcrumbs :breadcrumbs="breadcrumbs" />
      </base-content>
      <base-content class="tw-pt-0">
        <div class="tw-flex tw-justify-between">
          <h1 class="tw-text-xl sm:tw-text-2xl md:tw-text-3xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Brand Appearance</h1>
        </div>
      </base-content>
    </div>
    <base-content>
      <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3">
        <base-card class="tw-flex-col tw-w-full">
          <div>Business Logo</div>
          <div class="tw-flex tw-w-full tw-justify-center">
            <avatar class="tw-mt-3" :height="177" :width="177" :businessId="business.businessId" :editable="true" avatarType="business" />
          </div>
        </base-card>
        <base-card class="tw-flex-col tw-w-full">
          <div class="tw-mb-3">Brand Colors</div>
          <base-list-group>
            <base-list-item>
              <div class="tw-flex tw-justify-between">
                <div class="tw-text-sm tw-font-normal tw-my-auto">Primary Color</div>
                <div class="tw-flex">
                  <input v-model="business.primaryColor" type="color" maxlength="7" class="tw-h-6 tw-w-16 tw-bg-transparent tw-my-auto" />
                  <div class="tw-text-gray-500 tw-text-xs tw-my-auto">({{ business.primaryColor }})</div>
                </div>
              </div>
            </base-list-item>
            <base-list-item :showBottomBorder="false">
              <div class="tw-flex tw-justify-between">
                <div class="tw-text-sm tw-font-normal tw-my-auto">Secondary Color</div>
                <div class="tw-flex">
                  <input v-model="business.secondaryColor" type="color" maxlength="7" class="tw-h-6 tw-w-16 tw-bg-transparent tw-my-auto" />
                  <div class="tw-text-gray-500 tw-text-xs tw-my-auto">({{ business.secondaryColor }})</div>
                </div>
              </div>
            </base-list-item>
          </base-list-group>
          <div class="tw-flex tw-items-end tw-justify-end tw-mt-10">
            <base-button @click="save" :loading="isLoading">Save</base-button>
          </div>
        </base-card>
      </div>
    </base-content>
  </div>
</template>
<script>
import Avatar from "@/components/Avatar.vue";
import { mapActions } from "vuex";

export default {
  name: "BusinessBrand",
  props: {
    businessId: String,
  },
  components: {
    Avatar,
  },
  data() {
    return {
      isLoading: false,
      business: { primaryColor: "#cccccc", secondaryColor: "666666" },
    };
  },
  computed: {
    breadcrumbs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return [{ title: "Settings", onClick: () => this.$router.push(`/businesses/${this.businessId}/business`) }, { title: "Customize Brand" }];
    },
  },
  created() {
    this.loadBrand();
  },
  methods: {
    ...mapActions("businessActivation", { initBusinessActivation: "init" }),
    loadBrand() {
      this.isLoading = true;
      this.$axios
        .get(`/businesses/${this.$props.businessId}`)
        .then((res) => {
          this.business = res.data;

          //default to non-descript brand if no values
          if (res.data.primaryColor == null) {
            this.business.primaryColor = "#cccccc";
          }
          if (res.data.secondaryColor == null) {
            this.business.secondaryColor = "#666666";
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    save() {
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}`, this.business)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Brand Colors Saved", message: "Your brand color preferences were saved successfully" });
          this.initBusinessActivation();
        })
        .catch((err) => {
          this.isLoading = false;
          this.errors = err.response.data;
        });
    },
  },
};
</script>
